// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e1Qs","delete":"styles_delete__1O9IJ","update":"styles_update__33-zl","add":"styles_add__2GEmS"};